import styled from "styled-components";
import { device } from "../../../utils/helpers/breakpoints";

export const DocumentBreadCrumbStyle = styled.div`
  margin: 1.625rem 0 3.5rem;
  > div:first-child {
    display: flex;
    justify-content: space-between;
    > div:first-child {
      max-width: 37.5rem;
      > h2 {
        font-weight: 600;
        font-size: ${(props) => props.theme.fontSize["h2"].fontSize};
        line-height: ${(props) => props.theme.fontSize["h2"].lineHeight};
        margin: 0;
      }
      > p {
        font-size: ${(props) => props.theme.fontSize["h4"].fontSize};
        line-height: 1.375rem;
        word-wrap: all;
        margin: 1.563rem 0 0 0;
      }
      @media ${device.tablet} {
        max-width: 100%;
      }
    }
    > div:last-child {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      margin-bottom: 1rem;
    }
    @media ${device.tablet} {
      flex-direction: column;
      > div:last-child {
        margin-top: 2.188rem;
      }
    }
  }
`;

export const DocumentSection = styled.div`
  .logo-wrapper {
    display: flex;
    align-items: center;
    margin-top: 0.563rem;
    > img {
      width: 3rem;
      height: 3rem;
      border-radius: ${(props) => props.theme.borderRadius.sm};
    }
    > h2 {
      margin: 0 1.5rem;
      font-weight: 600;
      font-size: ${(props) => props.theme.fontSize["h3"].fontSize};
      line-height: ${(props) => props.theme.fontSize["h3"].lineHeight};
    }
  }
  > div:last-child {
    display: flex;
    align-items: center;
    margin-top: 1.375rem;
    > p {
      font-weight: bold;
      font-size: ${(props) => props.theme.fontSize["h4"].fontSize};
      line-height: 1.375rem;
      color: ${(props) => props.theme.colors.uburuDarkAsh};
      margin: 0.25rem 0;
      > span {
        font-weight: normal;
      }
    }
    @media ${device.mobileL} {
      margin-top: 1.688rem;
      flex-direction: column;
      align-items: flex-start;
      > svg {
        display: none;
      }
    }
  }
`;

export const ButtonArea = styled.div`
  display: flex;
  gap: 1.25rem;
`;
